import { media } from '@/core/hooks/useBreakpoints/useBreakpoints'
import { styled } from '@mui/system'

export const ActionPlanWrapper = styled('div')`
    flex: 1.8;

    ${media.lg`
        flex: 1.5;
    `}
    height: 100%;
`
